import Api from './api'

export default {
  namespaced: true,
  state: {
    studies: [],
    token: ''
  },
  getters: {
    studyUUIDs: (state) => {
      return state.studies.map(item => item.file_uuid)
    },
    shouldCompareBtnShow: (state, getters, rootState, rootGetters) => {
      let count = 0

      state.studies.forEach(study => {
        count += study.count
      })
      return count >= 2 && !rootGetters['config/restrictProViewer']
    },
    studies: state => state.studies
  },
  mutations: {
    setStudies (state, studies) {
      state.studies = studies
    },
    setToken (state, token) {
      state.token = token
    },
    clear (state) {
      state.studies = []
      state.token = ''
    }
  },
  actions: {
    async setStudies ({ commit, getters, dispatch }, studies) {
      studies = await Promise.all(
        studies.map(async study => {
          const foundStudy = (getters['studies'] || []).find(item => study.id_file === item.id_file)
          if (!foundStudy) {
            let count = 0
            try {
              const { data } = await Api.getV2(`file/${study.id_file}/contains-dicom-study`, {
                params: { type: 'vault' }
              })
              count = data.count
            } catch (e) {
              console.error(e)
              dispatch('feedback/addSnack', { text: this._vm.$tf('No studies to compare') }, { root: true })
            } finally {
              study.count = count
            }
            return study
          } else {
            return foundStudy
          }
        })
      )

      commit('setStudies', studies)
    },
    async getJWT ({ commit }, studyUUIDs) {
      try {
        const { data } = await Api.postV2('remote/sign/files', {
          data: studyUUIDs
        })

        commit('setToken', data.signed)

        return data
      } catch (error) {
        throw Error(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/compare.js